/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Camera_No_StreamInputs */

const vi_vehicle_camera_no_stream = /** @type {(inputs: Vehicle_Camera_No_StreamInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`VnetGPS chưa trả về phiên live camera`)
};

/**

* @param {Vehicle_Camera_No_StreamInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_camera_no_stream = /** @type {((inputs?: Vehicle_Camera_No_StreamInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Camera_No_StreamInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_camera_no_stream(inputs)
});